import { morphSection } from '@theme/section-renderer';
import { CartUpdateEvent } from '@theme/events';

const enhancedKeys = ['_atelier-body-profile','_atelier-shadow-profile','_atelier-label-profile','_atelier-controls-profile','customization-placement','customization-stripes','customization-font','customization-size','Label initials','Text color','Text shadow','Shadow color','Line 1','Line 2','Line 3'];
export function legacyMessagePayload(cart, key, message) {
  const item=cart.items.find(item=>item.key===key);
  if(!item)throw new Error('This cart item changed. Refresh the cart before editing.');
  if(enhancedKeys.some(key=>String(item.properties?.[key]??'').trim()))throw new Error('This design must retain its complete personalization settings.');
  if(!String(message||'').trim())throw new Error('Enter your message.');
  return {id:item.key,quantity:item.quantity,properties:{...item.properties,customization:String(message)}};
}
export function addPayload(data) {
  const id=Number(data.get('id')), quantity=Number(data.get('quantity')||1);
  if(!Number.isSafeInteger(id)||id<=0||!Number.isSafeInteger(quantity)||quantity<1)throw new Error('This offer is unavailable. Refresh your cart.');
  const properties={};
  for(const [key,value] of data.entries()) {const match=/^properties\[([^\]]+)\]$/.exec(key);if(match)properties[match[1]]=String(value);}
  return {items:[{id,quantity,properties}]};
}
let pending=false;
// Survives section replacement and applies to every cart-final form until reload.
let requiresRefresh=false;
function feedback(message) {
  document.querySelectorAll('[data-apolis-cart-feedback]').forEach(node=>{node.textContent=message;});
}
async function jsonGet(url) {
  const response=await fetch(url,{headers:{Accept:'application/json'},cache:'no-store'});
  if(!response.ok)throw new Error('Could not refresh your cart. Please reload the page.');
  return response.json();
}
document.addEventListener('submit',async event=>{
  const form=event.target;
  if(!(form instanceof HTMLFormElement)||!form.matches('[data-apolis-cart-action]'))return;
  event.preventDefault();
  if(requiresRefresh){feedback('Reload the page to confirm your cart before making another change.');return;}
  if(pending||form.dataset.locked==='true')return;
  const source=event.submitter;
  const data=new FormData(form);
  const root=window.Shopify?.routes?.root||'/';
  const components=[...document.querySelectorAll('cart-items-component[data-section-id]')];
  const sections=[...new Set(components.map(node=>node.dataset.sectionId).filter(Boolean))];
  if(!sections.length||sections.length>5){feedback('Please refresh the cart before making this change.');return;}
  const drawer=document.querySelector('cart-drawer-component');
  const wasOpen=Boolean(drawer?.querySelector('dialog')?.open);
  const drawerSections=new Set(components.filter(node=>node.hasAttribute('data-drawer')).map(node=>node.dataset.sectionId));
  pending=true; if(source)source.disabled=true;feedback('Updating your cart…');
  let posted=false,confirmed=false,rejected=false;
  try {
    let payload;
    const action=form.dataset.apolisCartAction;
    if(action==='message')payload=legacyMessagePayload(await jsonGet(root+'cart.js'),data.get('id'),data.get('properties[customization]'));
    else if(action==='add')payload=addPayload(data);
    else throw new Error('Unknown cart action.');
    payload.sections=sections;payload.sections_url=location.pathname;
    posted=true;
    const response=await fetch(root+(action==='message'?'cart/change.js':'cart/add.js'),{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(payload)});
    if(!response.ok){rejected=response.status>=400&&response.status<500;throw new Error(rejected?'This cart change was not accepted. Check availability and try again.':'Could not confirm the cart change. Refresh your cart before trying again.');}
    const result=await response.json();confirmed=true;
    const missing=sections.filter(id=>!result.sections?.[id]);
    if(missing.length){const rendered=await jsonGet(location.pathname+'?sections='+encodeURIComponent(missing.join(',')));result.sections={...result.sections,...rendered};}
    for(const id of sections){
      if(!result.sections?.[id])throw new Error('Cart saved, but the display could not refresh. Reload the page.');
      await morphSection(id,result.sections[id],{mode:drawerSections.has(id)?'hydration':'full'});
    }
    const cart=action==='message'?result:await jsonGet(root+'cart.js');
    document.dispatchEvent(new CartUpdateEvent(cart,'apolis-cart-final',{source:'apolis-cart-final',itemCount:cart.item_count,sections:result.sections}));
    const currentDrawer=document.querySelector('cart-drawer-component');
    if(wasOpen&&!currentDrawer?.querySelector('dialog')?.open)currentDrawer?.showDialog();
    feedback('Your cart has been updated.');
  } catch(error) {
    if(posted&&!rejected){requiresRefresh=true;form.dataset.locked='true';feedback(confirmed?'Your cart was saved, but the display could not refresh. Reload the page before making another change.':'We could not confirm the cart change. Reload the page to check it before trying again.');}
    else feedback(error.message||'The cart could not be updated.');
  } finally {
    pending=false;if(source&&form.dataset.locked!=='true')source.disabled=false;
  }
});
